var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { attrs: { xs12: "", sm12: "" } },
    [
      _c("ReportesBajasTransitoFilters", {
        on: { filters: _vm.handleFilters }
      }),
      _c("v-divider"),
      _c("ReportesBajasTransitoBtnActions", {
        attrs: { paramApi: _vm.paramApi, dataList: _vm.dataList }
      }),
      _c("MantenedorGrid", { attrs: { "grid-options": _vm.gridOptions } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }